import angular from 'angular';
import 'angular-gettext';

/* Modules */
import ApiModule from './../../../api/api.module';

/* Component */
import AccountsSwitchingComponent from './accounts-switching/accounts-switching.component';

/* Directives */
import CustomPageDirective from '../../../main/page.directive';
import MobileNavDirective from './mobile/mobile.component';
import MobileNavToggleDirective from './mobile/toggle-mobile.directive';
import NavLeftDirective from './left/left.component';
import {
  toggleNavCollapsedMin,
  collapseNav,
  highlightActive,
  toggleOffCanvas,
  toggleMenuOffCanvas,
  toggleFiltersOffCanvas,
  removeOffCanvas,
  toggleUserMenu,
  hideUserMenu,
  toggleCollapseableUserMenu,
} from './main/main.directive';

/* Services */
import AdminNavService from '../../../pages/admin/admin.nav.service';
import AlertsNavService from '../../alerts/alerts.nav.service';
import DevicesNavService from '../../devices/devices.nav.service';
import EquipmentNavService from '../../../equipment/equipment.nav.service';
import HelpItemsNavService from '../../help/help.items';
import HelpNavService from '../../help/help.nav';
import HelpAdminItemsService from '../../help/services/admin.items';
import HelpAlertsItemsService from '../../help/services/alerts.items';
import HelpAssetsItemsService from '../../help/services/assets.items';
import HelpDevicesItemsService from '../../help/services/devices.items';
import HelpMaintenanceItemsService from '../../help/services/maintenance.items';
import HelpMapItemsService from '../../help/services/map.items';
import HelpReportsItemsService from '../../help/services/reports.items';
import HelpUsersItemsService from '../../help/services/users.items';
import MaintenanceNavService from '../../maintenance/nav.service';
import MapNavService from '../../map/map.nav.service';
import ReportsNavService from '../../reports/reports.nav.service';
import TSeriesNavService from '../../t-series/t-series.nav.service';
import UserProfileNavService from '../../user-profile/profile.nav.service';
import AccessManagemantNavService from './../../access-management/access-managment.nav.service';
import SiteNaveService from '../../Sites/sites.nav.service';

const navModule = angular
  .module('app.nav', ['gettext', ApiModule])
  .component('accountsSwitching', AccountsSwitchingComponent)
  /* Default Directives */
  .directive('customPage', CustomPageDirective)
  .directive('navLeft', NavLeftDirective)
  .directive('sideNav', MobileNavDirective)
  .directive('toggleSideNav', MobileNavToggleDirective)
  /* Named Directives */
  .directive('toggleNavCollapsedMin', toggleNavCollapsedMin)
  .directive('collapseNav', collapseNav)
  .directive('highlightActive', highlightActive)
  .directive('toggleOffCanvas', toggleOffCanvas)
  .directive('toggleMenuOffCanvas', toggleMenuOffCanvas)
  .directive('toggleFiltersOffCanvas', toggleFiltersOffCanvas)
  .directive('removeOffCanvas', removeOffCanvas)
  .directive('toggleUserMenu', toggleUserMenu)
  .directive('hideUserMenu', hideUserMenu)
  .directive('toggleCollapseableUserMenu', toggleCollapseableUserMenu)
  /* Services */
  .service('adminNavService', AdminNavService)
  .service('alertsNavService', AlertsNavService)
  .service('devicesNavService', DevicesNavService)
  .service('equipmentNavService', EquipmentNavService)
  .service('helpItemsService', HelpItemsNavService)
  .factory('helpNavService', HelpNavService)
  .service('helpAdminItemsService', HelpAdminItemsService)
  .service('helpAlertsItemsService', HelpAlertsItemsService)
  .service('helpAssetsItemsService', HelpAssetsItemsService)
  .service('helpDevicesItemsService', HelpDevicesItemsService)
  .service('helpMaintenanceItemsService', HelpMaintenanceItemsService)
  .service('helpMapItemsService', HelpMapItemsService)
  .service('helpReportsItemsService', HelpReportsItemsService)
  .service('helpUsersItemsService', HelpUsersItemsService)
  .service('maintenanceNavService', MaintenanceNavService)
  .service('mapNavService', MapNavService)
  .service('reportsNavService', ReportsNavService)
  .service('tSeriesNavService', TSeriesNavService)
  .service('userProfileNavService', UserProfileNavService)
  .service('accessManagemantNavService', AccessManagemantNavService)
  .service('siteNaveService', SiteNaveService);

export default navModule.name;
